var React = require('react');

function TempWash (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop---Phase-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Ikoner/Wash","transform":"translate(.333 -3.175)","stroke":"#000","strokeWidth":"2"},[React.createElement("path",{"id":"Rectangle-17","d":"M1.006 3.56l4.105 33H35.9l4.105-33h0","key":0}),React.createElement("path",{"d":"M2.496 12.613c2.157 0 3.381-3.629 5.84-3.629s3.478 3.629 6.068 3.629c2.59 0 3.561-3.629 6.048-3.629s3.5 3.629 6.29 3.629c2.789 0 3.468-3.629 5.97-3.629 2.5 0 3.388 3.629 5.884 3.629","id":"Line-6","strokeLinecap":"square","key":1})])));
}

TempWash.defaultProps = {"width":"42","height":"35","viewBox":"0 0 42 35"};

module.exports = TempWash;

TempWash.default = TempWash;
